(() => {
  const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim();
  const shortenCourseTitle = (text) => {
    let t = normalize(text);
    t = t.replace(/\s*[—–|-]\s*Private\s+(?:Mobile|On[- ]Site)\s+(?:Training|Appointment|Training Package)\s*$/i, '');
    t = t.replace(/^Private\s+(?:Mobile|On[- ]Site)\s+(?:Training|Appointment|Training Package)\s*[—–|-]\s*/i, '');
    return t;
  };
  const deDupeH1 = () => {
    if (!document.body.classList.contains('template-page')) return;
    const seen = new Set();
    document.querySelectorAll('#MainContent h1').forEach((h1) => {
      const key = normalize(h1.textContent).toLowerCase();
      if (!key) return;
      if (seen.has(key)) {
        h1.setAttribute('aria-hidden', 'true');
        h1.style.display = 'none';
      } else seen.add(key);
    });
  };
  const polishCardTitles = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const selectors = [
      '.product-card__content [class*="product-title"]',
      '.resource-card[data-resource-type="product"] .resource-card__title',
      'product-card a[href*="/products/"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (el.children.length) return;
      const original = normalize(el.textContent);
      const shorter = shortenCourseTitle(original);
      if (shorter && shorter !== original) {
        el.textContent = shorter;
        el.setAttribute('title', original);
      }
    });
  };
  const run = () => { deDupeH1(); polishCardTitles(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
